import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseObjectAPI } from 'src/app/models/responseObjectAPI';
import { RequirementService } from 'src/app/services/requirement.service';

@Component({
    selector: 'app-return-requirement-dialog',
    templateUrl: './return-requirement-dialog.component.html',
    styleUrls: ['./return-requirement-dialog.component.scss'],
    standalone: false
})
export class ReturnRequirementDialogComponent implements OnInit {

  returning = false;
  form = new FormGroup({
		commentArea: new FormControl('')
  });

  @Input() requirementId;
  @Output() returned = new EventEmitter();

  visibilityId: number;

  constructor(
    public activeModal: NgbActiveModal,
    public requirementService: RequirementService) { }

  ngOnInit() {
  }

  onSubmit() {
    this.returning = true;
    const body = {
      requirementid: this.requirementId,
      comment: this.form.get('commentArea').value
    };
    this.requirementService.returnRequirement(body).subscribe((resp: ResponseObjectAPI) => {
      this.returning = true;
      this.returned.emit(true);
      this.activeModal.close();
    });
  }

}
